import React from 'react';
import { Table } from 'antd';
import { useQuery } from '@tanstack/react-query';
import { fetchUserAccessPage } from '../../../cores/api/api-dashboard';
import { columnUserVisitPage } from '../../../utils/common-chart';
export default function UserActivityTable({ params }) {
    var _a;
    const _useQuery = useQuery({
        queryKey: ['fetchUserAccessPage', params],
        queryFn: () => fetchUserAccessPage(params),
        enabled: !!params.start_date
    }), data = _useQuery.data, isLoading = _useQuery.isLoading, isFetching = _useQuery.isFetching;
    return /*#__PURE__*/ React.createElement(Table, {
        rowKey: "id",
        loading: isLoading || isFetching,
        dataSource: (_a = data === null || data === void 0 ? void 0 : data.data) !== null && _a !== void 0 ? _a : [],
        columns: columnUserVisitPage,
        pagination: false
    });
}
